import { Form, Select, Flex } from 'antd';
import { TextInput } from '~/app/components/common/TextInput';
import { Button } from '~/app/components/common/Button/';
import { Language } from '@evimo/types/enums/language';
import type { CurrentUser } from '@evimo/types';

type UserInfoFormProps = {
  user: CurrentUser | null;
  name: string;
  setName: (name: string) => void;
  language: Language;
  setLanguage: React.Dispatch<React.SetStateAction<Language>>;
  t: (key: string) => string;
  languageOptions: { label: string; value: Language }[];
  saving: boolean;
  nameError: { name?: string; email?: string };
  isNameFormDisabled: boolean;
  handleNameSave: () => void;
};

export const UserInfoForm: React.FC<UserInfoFormProps> = ({
  user,
  name,
  setName,
  language,
  setLanguage,
  t,
  languageOptions,
  saving,
  nameError,
  isNameFormDisabled,
  handleNameSave,
}) => (
  <Form layout="vertical" className="app-full-width" onFinish={handleNameSave}>
    <Flex align="center" gap={24} className="app-mb-24">
      <Flex className="app-flex-1" gap={16}>
        <Form.Item
          label={t('common:placeholders.name')}
          name="name"
          className="app-flex-1 app-form-item-no-margin"
          initialValue={name}
          rules={[{ required: true, message: 'Name required' }]}
          validateStatus={nameError.name ? 'error' : ''}
          help={nameError.name}
        >
          <TextInput
            value={name}
            onChange={(e) => setName(e.target.value)}
            size="middle"
          />
        </Form.Item>
        <Form.Item
          label="Language"
          name="language"
          className="app-flex-1 app-form-item-no-margin"
          initialValue={language}
        >
          <Select
            options={languageOptions}
            value={language}
            onChange={setLanguage}
            className="app-full-width"
          />
        </Form.Item>
        <Form.Item
          label={t('common:labels.email')}
          name="email"
          className="app-flex-1 app-form-item-no-margin"
          initialValue={user?.email}
          validateStatus={nameError.email ? 'error' : ''}
          help={nameError.email}
        >
          <TextInput value={user?.email} readOnly disabled size="middle" />
        </Form.Item>
      </Flex>
      <Button
        htmlType="submit"
        type="primary"
        loading={saving}
        loadingText="Saving..."
        className="app-flex-end"
        rounded
        disabled={isNameFormDisabled}
      >
        {t('common:buttons.save')}
      </Button>
    </Flex>
  </Form>
);
